import { ComplexEnum } from '../../utils/complexEnum'
import {
  AsphaltLot,
  ConcreteTestSet,
  ControlPoint,
  DensityLot,
  Inspection,
  PunchList,
} from './instances'

export type PhotoExportClassTypeItem =
  | typeof AsphaltLot
  | typeof ConcreteTestSet
  | typeof ControlPoint
  | typeof DensityLot
  | typeof Inspection
  | typeof PunchList
type ID = PhotoExportClassTypeItem['id']

class PhotoExportClassTypeEnum extends ComplexEnum<
  'PhotoExportClassType',
  PhotoExportClassTypeItem,
  ID
> {
  readonly typename = 'PhotoExportClassType'
  get values() {
    return [
      this.AsphaltLot,
      this.ConcreteTestSet,
      this.ControlPoint,
      this.DensityLot,
      this.Inspection,
      this.PunchList,
    ]
  }
  AsphaltLot = AsphaltLot
  ConcreteTestSet = ConcreteTestSet
  ControlPoint = ControlPoint
  DensityLot = DensityLot
  Inspection = Inspection
  PunchList = PunchList
}

export const PhotoExportClassType = new PhotoExportClassTypeEnum()
